"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationOrderErrorCode = void 0;
var ValidationOrderErrorCode;
(function (ValidationOrderErrorCode) {
    ValidationOrderErrorCode["Expired"] = "ORDER_EXPIRED";
    ValidationOrderErrorCode["AlreadyApproved"] = "CHARGE_ALREADY_APPROVED";
})(ValidationOrderErrorCode = exports.ValidationOrderErrorCode || (exports.ValidationOrderErrorCode = {}));
//# sourceMappingURL=ValidationOrderErrorCode.js.map